module.exports = __webpack_public_path__ + "static/images/styles/images/table/table-head-cell-active-right.e524f639.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/table/table-head-cell-active-right.png
// module id = 3821
// module chunks = 11